var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Divider',{staticStyle:{"color":"#fff"},attrs:{"dashed":""}},[_vm._v("资源分布统计")]),_c('div',[_c('Table',{attrs:{"stripe":"","data":_vm.tableData,"columns":_vm.tableColumns}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }